export function formatMoney(value: string | number | undefined | null, currency: string, locale: string): string | undefined {
  if (value === undefined || value === null || value === '')
    return undefined

  const amount = typeof value === 'number' ? value : Number(value)
  if (Number.isNaN(amount))
    return undefined

  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount)
}
